import React, { Component } from 'react'

import { Wrapper, StyledCheck } from './styles'

class CheckBox extends Component {
  render() {
    const { children, name, handleChange, value, dataKey } = this.props
    return (
      <Wrapper>
        <StyledCheck>
          <input data-key={dataKey} type="checkbox" name={name} onChange={handleChange} id={name} checked={value} />
          <label htmlFor={name} />
        </StyledCheck>
        <p onClick={handleChange} data-key={dataKey} value={value}>
          {children}
        </p>
      </Wrapper>
    )
  }
}

export default CheckBox



// WEBPACK FOOTER //
// ./src/components/CheckBox/index.js